import { createFileRoute } from '@tanstack/react-router';
import { ParentLayout } from '../features/parent/ParentLayout';
import { RequireAuth, STATS_ROLES } from '../features/auth/RequireAuth';

export const Route = createFileRoute('/parent')({
  component: ParentRoute,
});

function ParentRoute(): React.JSX.Element {
  return <RequireAuth role={STATS_ROLES}>{(me) => <ParentLayout me={me} />}</RequireAuth>;
}
